import Row from '../../core/components/box/row';
import styled, { useTheme } from 'styled-components';
import SizedBox from '../../core/components/box/sizedBox';
import { setToLS } from '../../../lib/util/useLocalStorage';
import { useRecoilState } from 'recoil';
import langAtom from '../../../1_application/core/langAtom';

interface LanguageButtonProps {
  selected: boolean;
}

const LanguageButton = styled.div<LanguageButtonProps>`
  font-family: Outfit;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-decoration-line: ${(props) => (props.selected ? 'underline' : 'none')};
  color: ${(props) => (props.selected ? '#000000' : '#999999')};

  &:hover {
    cursor: pointer;
  }
`;

const LanguageToggle = () => {
  const [lang, setLang] = useRecoilState(langAtom);
  const theme = useTheme();

  const setLangAndSave = (lang: 'english' | 'indonesian') => {
    setLang(lang);
    setToLS('lang', lang);
  };

  return (
    <Row>
      <LanguageButton
        selected={lang === 'indonesian'}
        onClick={() => setLangAndSave('indonesian')}
      >
        {theme.langs.indonesian}
      </LanguageButton>
      <SizedBox width={14}></SizedBox>
      <LanguageButton
        selected={lang === 'english'}
        onClick={() => setLangAndSave('english')}
      >
        {theme.langs.english}
      </LanguageButton>
    </Row>
  );
};

export default LanguageToggle;
